"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.SEIZURE = exports.GARNISHMENT = exports.FORECLOSURE = exports.REPOSSESSION = void 0;
exports.REPOSSESSION = "repossession";
exports.FORECLOSURE = "foreclosure";
exports.GARNISHMENT = "garnishment";
exports.SEIZURE = "seizure";
exports.OTHER = "other";